import { OrganizationMember } from "@/store/models";
import AbstractSubTribeRepository from "./abstractSubTribeRepository";

export default class TribeDiscussionPendingMembersRepository extends AbstractSubTribeRepository<OrganizationMember> {
  constructor() {
    super({
      subject: "TribeDiscussionMembers",
      type: "messaging",
      subType: "members",
      endpoint: "rooms/{id}/pendingmembers",
      TypeConstructor: OrganizationMember,
    });
  }

  public checkPending(ids: string[]): Promise<string[]> {
    return this.api.client
      .post(`${this.endpoint}/check`, { ids })
      .then((response) => response.data as string[]);
  }

  public save(): Promise<OrganizationMember> {
    return Promise.reject("Not implemented");
  }

  public delete(): Promise<OrganizationMember> {
    return Promise.reject("Not implemented");
  }
}
